var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('zingchart',{attrs:{"height":_vm.height,"width":_vm.width,"data":_vm.graph_data,"id":_vm.$options.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }